var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcLoginBgDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 862,
    viewBox: "0 0 1440 862",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19057_46009)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 862,
    fill: "#1C1D24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.3 497.341C1742.16 496.051 1740.9 494.22 1738.48 493.105C1732.7 490.447 1721.89 488.757 1716.95 487.69C1687.39 481.302 1657.46 474.611 1627.24 472.329C1598.38 470.151 1570.42 473.968 1542.02 478.74C1494.7 486.695 1426.16 498.519 1381 515.5C1336.12 532.375 1313.06 549.431 1272.14 574.372C1236.8 595.91 1198.37 619.932 1178.1 656.16C1164.54 680.395 1156 719.003 1166.62 747.716C1175.64 772.131 1213.11 799.945 1235.66 796.99C1282.02 790.914 1302.72 747.553 1308.73 697.797C1315.37 642.75 1272.14 599.42 1230 586.97C1183.82 580.643 1179.37 577.454 1116.23 603.625C999.641 670.03 924.992 849.994 916.361 862.835M773.5 976C748.507 985.874 422.8 904.801 398.584 896.843",
    stroke: "#434348",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "8 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.5503 499.799C69.8147 495.748 178.423 436.436 216.089 362.082C261.007 273.413 280.419 149.087 226.765 59.4734C216.148 41.7406 200.732 26.4113 178.803 25.0914C156.153 23.7283 138.376 37.8705 129.663 57.8249C116.71 87.4906 123.431 127.706 133.117 157.282C147.462 201.084 169.49 242.587 192.854 282.171C218.499 325.619 249.437 367.231 293.174 393.873C389.451 452.519 507.593 439.179 592.093 384.679C672.506 332.815 925.898 -5.50562 930.167 -21.0352",
    stroke: "#434348",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "8 16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19057_46009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 862,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcLoginBgDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icLoginBgDark.3214d4bed3ab268897ec3e46af7f3fcb.svg";